import { H1, Chip, TertiaryButton } from "@coherehealth/common";
import { Grid, Box, Divider, Tooltip } from "@mui/material";
import ShieldIcon from "@mui/icons-material/Shield";
import SupervisorSearch from "./SupervisorSearch";
import { GuardrailType, RouteConfigByCaseType } from "@coherehealth/qm-api";
import { GUARDRAIL_LABELS } from "../../util/QueueUtil";
import { useLaunchDarklyFeatureFlag } from "../../hooks/useLaunchDarklyFeatureFlag";

interface PageHeaderProps {
  headerLabel: string;
  chipLabel?: string;
  tertiaryButtonTestid?: string;
  tertiaryButtonLabel?: string;
  tertiaryButtonAction?: () => void;
  hideBottomLine?: boolean;
  supervisorSearch?: boolean;
  routeConfigByCaseType?: RouteConfigByCaseType;
  activeQueueId?: string;
  guardrails?: GuardrailType[];
}

const PageHeader = ({
  headerLabel,
  chipLabel,
  hideBottomLine,
  tertiaryButtonTestid,
  tertiaryButtonAction,
  tertiaryButtonLabel,
  supervisorSearch,
  routeConfigByCaseType,
  activeQueueId,
  guardrails,
}: PageHeaderProps) => {
  const { featureFlagEnabled: qmQueueGuardrails } = useLaunchDarklyFeatureFlag({
    featureFlagName: "qmQueueGuardrails",
  });
  const activeGuardrails = qmQueueGuardrails && guardrails && guardrails.length > 0 ? guardrails : null;

  return (
    <Grid container style={{ display: "flex", justifyContent: "space-between" }}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <H1 style={{ marginRight: "0.5em" }}>{headerLabel}</H1>
        {activeGuardrails && (
          <Tooltip
            placement="bottom"
            componentsProps={{
              tooltip: { sx: { fontSize: "14px", padding: "12px 16px", maxWidth: "none" } },
            }}
            title={
              <>
                <div>Guardrails enabled:</div>
                <ul style={{ margin: 0, paddingLeft: "1em" }}>
                  {activeGuardrails.map((guardrail) => (
                    <li key={guardrail}>{GUARDRAIL_LABELS[guardrail]}</li>
                  ))}
                </ul>
              </>
            }
          >
            <ShieldIcon
              fontSize="small"
              data-testid="queue-guardrail-shield"
              titleAccess="Queue guardrails enabled"
              sx={{ mr: "0.5em", color: "text.primary" }}
            />
          </Tooltip>
        )}
        {chipLabel && <Chip label={chipLabel} style={{ borderRadius: "4px", height: "24px", minWidth: "79px" }} />}
        {tertiaryButtonLabel && (
          <Box sx={{ pt: "4px" }}>
            <TertiaryButton
              style={{ borderRadius: "4px", height: "100%", padding: "4px", alignItems: "center" }}
              onClick={(event) => {
                tertiaryButtonAction && tertiaryButtonAction();
                event.currentTarget.blur();
              }}
              data-testid={tertiaryButtonTestid}
            >
              {tertiaryButtonLabel}
            </TertiaryButton>
          </Box>
        )}
      </Box>
      {supervisorSearch && (
        <Box>
          <SupervisorSearch routeConfigByCaseType={routeConfigByCaseType} activeQueueId={activeQueueId} />
        </Box>
      )}
      {!hideBottomLine && <Divider variant="fullWidth" sx={{ width: "100%", my: "1em" }} />}
    </Grid>
  );
};

export default PageHeader;
